
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import listado_etiquetas from '@view/a-pedidos-ml/pc/lista/listados/listado-etiquetas.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado_etiquetas
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = true;
            this.Limite = null;
            this.Seleccionada = 'pendiente';
        }


        public AbrirEtiquetas: boolean  =false;


        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = false;
        public Limite: number = null;
        public Seleccionada: string = 'pendiente';
        public Opciones: { Id: string, Descripcion: string; }[] = [
            //{ Id: 'auto', Descripcion: 'Marca automática' },
            { Id: 'pendiente', Descripcion: 'Todo lo pendiente' },
            //{ Id: 'mercado-envios', Descripcion: 'Solo MercadoEnvios' },
            //{ Id: 'mercado-envios-flex', Descripcion: 'Solo MercadoEnvios Flex' },
            //{ Id: 'retira-cliente', Descripcion: 'Solo retira cliente' },

        ];

        public get Ok(): boolean
        {
            return this.Seleccionada && this.Seleccionada.length > 0;
        }

        public Pedidos: Pedido[] = [];
        public Cargando: boolean = false;
        async Descargar()
        {

            this.Pedidos = await Pedido.Marca( this.Seleccionada, this.Limite, this.Buscador.Filtros.Tipos[this.Buscador.Filtros.Valores.Tipo].Valor );

            if ( !this.Pedidos.hasRows() )
            {
                Utiles.Notificaciones.Info( 'No se encontraron ventas' );
                return;
            }

            if ( ! await Utiles.Mensajes.SiNo( 'Crear hoja de piso', `¿Crear hoja de piso con ${this.Pedidos.length} pedidos?` ) )
                return;

            this.Cargando = true;
            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLHojaDePiso( this.Pedidos );
            if ( pdf )
            {
                for ( let p of this.Buscador.Items )
                {
                    if ( this.Pedidos.findIndex( x => x.Id == p.Id ) != -1 )
                        p.Estado = Pedidos.Estados.Preparando;
                }
                await Wait( 100 );
                this.Controlador.RecargarEstadistica();
                this.AbrirEtiquetas = !this.AbrirEtiquetas;
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la hoja de piso` );

            }
            Utiles.GenerandoArchivo( false);
            this.Cargando = false;
        }

        Cerrar()
        {
            this.Abierto = false;
        }

    }
